import { baseUrl } from './util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';

// 获取查询shopify产品数据接口
export const submitForm = (data, locale: string) => {
    return request(`${baseUrl(locale)}/dpuForm${setLocaleQuery(locale)}`, {
        method: 'post',
        data,
    });
};
